import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import { FormBuilder, FormControl, FormGroup, Validator, Validators} from '@angular/forms';
import {environment} from "../../../../../../environments/environment";
import {ApiHttpService} from "../../../../../_services/api-http.service";
import {AlertService} from 'src/app/_services/alert.service';
import { StorageService } from 'src/app/_services/storage.service';
import {getAllErrors, moreThanOneWhiteSpaceValidator} from 'src/app/common/common.validators';
import { MerchantService } from '../merchant.service';
import {DataTable} from "simple-datatables";
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import { TitleCasePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
const {API_URL} = environment;

@Component({
  selector: 'app-merchant-blocked',
  templateUrl: './merchant-blocked.component.html',
  styleUrls: ['./merchant-blocked.component.scss']
})
export class MerchantBlockedComponent implements OnInit {
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  merchatstatusform: FormGroup;
  isForm1Submitted: boolean;
  @Input() merchantStatusConfig: any;
  @Input() onMerchantMId: EventEmitter<any> = new EventEmitter<any>();
  data: any;
  Resdata: any;
  merchantId: any
  loading: boolean =false;
  remarkData: any=[];
  dataTable: DataTable;
  segmentData: any;
  loader: any = false;
  pageSize: number = 10;
  status : any;
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    filter: true,
    resizable: true
  };

  public columnDefs: ColDef[] = [
    {field: 'id', tooltipField: 'id', headerName: 'ID', hide: true},
     {field: 'appStatus', tooltipField: 'productId', headerName: 'Status'},
    {field: 'appRemark', tooltipField: 'bankName', headerName: 'Remark'},
    {field: 'addedBy', tooltipField: 'isVerified', headerName: 'Added By'},
    {field: 'addedOn', tooltipField: 'bankName', headerName: 'Added On'},
  ];

  public tableSelectedColumn: ColDef[] = [...this.columnDefs];

  constructor(private services: ApiHttpService,private router : Router, private alertService: AlertService, private formbuilder: FormBuilder,private storage:StorageService,private merchantService: MerchantService) {

    this.data = this.merchantStatusConfig
    this.merchatstatusform = formbuilder.group({
      Status: ["",[ Validators.required]],
      // Segment: ["",[ Validators.required]],
      Remark: ["", [Validators.required,moreThanOneWhiteSpaceValidator(),Validators.maxLength(200)]],
    })
    if (this.merchatstatusform) {
      this.merchatstatusform.get('Segment')?.valueChanges.subscribe(value => {
        console.log('Selected Segment:', value); // Log selected value to console
      });
    }

  }

  get form1() {
    return this.merchatstatusform.controls;
  }

  ngOnInit(): void {
    this.merchantStatusDropdown();
    this.merchantSegmentDropdown();

    this.onMerchantMId.subscribe((res) => {
      console.log(res)
      this.merchantId = res.mobile,
      this.status = res.walletStatus
      // this.fetchRemarkList(),
      //alert(res),
      this.merchatstatusform.controls['Status'].setValue(''),
      this.loading = false,
      this.reset(),
      this.isForm1Submitted = false

      this.status === 'CLOSED' ? this.merchatstatusform.disable() : this.merchatstatusform.enable()

      this.merchantService.getOnboardingRemark(this.merchantId,"Status")
              .subscribe((data: any) => {
                console.log(data);
                this.remarkData = data.response.data;
              })
    }

      )

      // alert("calling mid"+this.merchantId)
      // if(this.merchantId==!''&& this.merchantId==!"undefined"){
      //   alert("calling")

      // }

  }

  merchantStatusChange(formvalue : any){
    debugger;
    console.log("Mobile :"+this.merchantId);
    console.log("Status :"+formvalue.Status);
    console.log("Comment :"+formvalue.Remark);
    if (this.status === 'CLOSED') {
      this.alertService.errorAlertWithMessage("This merchant is permanently closed, status cannot be changed");
      return;
    }
    if(this.status == formvalue.Status){
     let tempStatus = this.status || TitleCasePipe
     this.alertService.errorAlertWithMessage("Status is already "+tempStatus);
     return;
    }
    if (formvalue.Status === 'CLOSED') {
      Swal.fire({
        title: 'Are you sure?',
        text: 'Closing this merchant is permanent and cannot be undone or reverted back.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, close it',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          this.submitMerchantStatusChange(formvalue);
        }
      });
      return;
    }
    this.submitMerchantStatusChange(formvalue);
  }

  private submitMerchantStatusChange(formvalue: any) {
    if (this.merchatstatusform.valid) {
       console.log("Valid");
       let statusChangeRequest = {
          "userId" : this.merchantId,
          "status" : formvalue.Status,
          "remark" : formvalue.Remark
        }
       this.merchantService.merchantStatusChange(statusChangeRequest)
         .subscribe((data:any) => {
           console.log("Response"+JSON.stringify(data.response.message));
           if(data.response.status == 200){
             Swal.fire('Merchant status updated successfully','','success').then((result)=>{
              if (result.isConfirmed) {
                this.closeModal.emit({
                  showModal: false
                })
                this.router.navigate(['/merchants/merchant-master']);
              }
            });
            //going to call a api for push notification on and send a sms on mobile or email
            this.pushNotification(statusChangeRequest);
           }else{
             Swal.fire(data.response.message,'','error').then((result)=>{
              if (result.isConfirmed) {
                this.closeModal.emit({
                  showModal: false
                })
                this.router.navigate(['/merchants/merchant-master']);
              }
            });
           }
         })

     }else{
       this.alertService.errorAlertWithMessage("Mandatory Fields are missing");
         console.log("Not Valid");
     }

   }

  MerchantStatus(formvalue: any) {
    debugger
    if (this.merchatstatusform.valid) {
      let data1 = {
        "Mid": this.merchantId,
        "Status": formvalue.Status,
        "Remark": formvalue.Remark,
        // "Segment": formvalue.Segment,
        "Approvel_type": "",
        "Added_By": this.storage.getUserName().toString()
      }
      this.loading = true
      document?.getElementById('loading')?.classList.add("spinner-border")
      document?.getElementById('loading')?.classList.add("spinner-border-sm")
      this.services.post(`${API_URL}/checkAllStatus`,data1).subscribe((res) => (
        this.reset(),
          res.text=="SUCCESS" ?
      this.services
        .post(
          `${API_URL}/ChangeMerchantStatus`, data1
        )
        .subscribe((data) => {

           if(formvalue.Status=="Send to Negative"&&data.length <= 0){
            this.alertService.successAlert(
              "Status successfully updated"
            )
            this.reset();
            this.isForm1Submitted = false;
            this.closeModal.emit({
              showModal: false
            })
          }
          if (data.length > 0) {
            if (data[0].status != "false") {
              this.alertService.successAlert(
                "Status successfully updated"
              )
              this.reset();
              this.isForm1Submitted = false;
              this.closeModal.emit({
                showModal: false
              })
            }

            else {
              this.alertService.errorAlert({
                html: `Can not change the status, ${data[0].Message}`
              }).then(() => {
                this.reset();
                this.isForm1Submitted = false;
                this.closeModal.emit({
                  showModal: false
                });
              })

            }
          }
          this.loading = false
          document?.getElementById('loading')?.classList.remove("spinner-border")
          document?.getElementById('loading')?.classList.remove("spinner-border-sm")
        }): this.alertService.errorAlert({
          html: `Can not change the status, ${res[0].Message}`
        }).then(() => {
          this.reset();
          this.isForm1Submitted = false;
          this.closeModal.emit({
            showModal: false
          });
        }),
        this.closeModal.emit({
          showModal: false
        })
    ));
    }
    this.isForm1Submitted = true;
  }

  // MerchantStatus(formvalue: any) {
  //   debugger
  //   if (this.merchatstatusform.valid) {
  //     let data = {
  //       "Mid": this.merchantId,
  //       "Status": formvalue.Status,
  //       "Remark": formvalue.Remark,
  //       "Approvel_type": "",
  //       "Added_By": this.storage.getUserName().toString()
  //     }
  //     this.loading = true
  //     document?.getElementById('loading')?.classList.add("spinner-border")
  //     document?.getElementById('loading')?.classList.add("spinner-border-sm")
  //     this.services
  //       .post(
  //         `${API_URL}/ChangeMerchantStatus`, data
  //       )
  //       .subscribe((data) => {

  //          if(formvalue.Status=="Send to Negative"&&data.length <= 0){
  //           this.alertService.successAlert(
  //             "Status successfully updated"
  //           )
  //           this.reset();
  //           this.isForm1Submitted = false;
  //           this.closeModal.emit({
  //             showModal: false
  //           })
  //         }
  //         if (data.length > 0) {
  //           if (data[0].status != "false") {
  //             this.alertService.successAlert(
  //               "Status successfully updated"
  //             )
  //             this.reset();
  //             this.isForm1Submitted = false;
  //             this.closeModal.emit({
  //               showModal: false
  //             })
  //           }

  //           else {
  //             this.alertService.errorAlert({
  //               html: `Can not change the status, ${data[0].Message}`
  //             }).then(() => {
  //               this.reset();
  //               this.isForm1Submitted = false;
  //               this.closeModal.emit({
  //                 showModal: false
  //               });
  //             })

  //           }
  //         }
  //         this.loading = false
  //         document?.getElementById('loading')?.classList.remove("spinner-border")
  //         document?.getElementById('loading')?.classList.remove("spinner-border-sm")
  //       });

  //   }
  //   this.isForm1Submitted = true;
  // }


  merchantStatusDropdown() {
//alert("Resdata")
    let postdata = {
      "Type": "8",
      "Value": "merchant_status"
    }

    // return this.services
    //   .post(
    //     `${API_URL}/GetDropdown`, postdata
    //   )
    //   .subscribe((res) => (this.Resdata = res));
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.merchantService.getOnboardingRemark(this.merchantId,"KYC")
              .subscribe((data: any) => {
                console.log(data);
                this.remarkData = data.response.data;
              })
  }

  merchantSegmentDropdown() {
    // return this.services.get(`${API_URL}/getAllSegment`).subscribe((res) => {
    //   this.segmentData = JSON.parse(res.data);
    // });
  }


  reset() {
    this.merchatstatusform.reset(); // Reset form data
    this.merchatstatusform.markAsUntouched(); // Reset form data
    this.merchatstatusform.updateValueAndValidity(); // Reset form data
  }

  fetchRemarkList(){
    debugger
   // alert(this.merchantId)
    this.merchantService.fetchRemarkList(this.merchantId).subscribe((data)=>{
  // alert(data[0]?.addedBy)
  console.log("list======"+JSON.stringify(data));
  this.remarkData = data
  this.dataTable ? this.dataTable.destroy() : console.log(this.remarkData)
  this.remarkData ? this.dataTable = new DataTable("#dataTableExample") : this.dataTable.destroy()
  if (this.remarkData) {
    this.remarkData.forEach((element: any) => {
      this.dataTable.rows().add(Object.values(element));
    })
  }
                }

      )
  }

  pushNotification(statusChangeRequest: any) {
    debugger;
  this.merchantService.sendMerchantDecisionNotification(statusChangeRequest).subscribe(
    (response: any) => {
      console.log('Notification Response:', response);

      if (response && response.response) {
        console.log(response.response.message);

        // Optional: show success toast
        // this.toastr.success(response.response.message);
      }
    },
    (error) => {
      console.error('Failed to send notification:', error);

      // Optional: show error toast
      // this.toastr.error('Failed to send notification');
    }
  );
}

}
